import { FormInitializerReturnType, stringSchema } from 'src/Configuration/validation'
import { useAttachedCompanies } from 'src/Libs/retrofit'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { boolean, number, object } from 'yup'

const MIN_STRING_LENGTH = 3
const MAX_STRING_LENGTH = 1000

export interface GrantCompanyAccessFormData {
  company: number | string | undefined
  writePermission: boolean
  readPermission: boolean
  reason: string
}
/**
 *  Initializes the form for granting a company access to an installation
 * @param installationId string
 * @returns initialValues and validationSchema for granting company access form
 */
export const useGrantCompanyAccessFormInitializer = (
  installationId: string
): FormInitializerReturnType<GrantCompanyAccessFormData, GrantCompanyAccessFormData> => {
  const { data: companyAccountLinks } = useAttachedCompanies(installationId)
  const alreadyAttachedCompanyIds = companyAccountLinks.map(elem => elem.companyId)

  const { t } = useCustomTranslation()
  const stringSchemaWithTranslation = stringSchema(t)

  const initialValues: GrantCompanyAccessFormData = {
    company: undefined,
    writePermission: false,
    readPermission: true,
    reason: '',
  }

  const validationSchema = object().shape({
    reason: stringSchemaWithTranslation({ maxLength: MAX_STRING_LENGTH, minLength: MIN_STRING_LENGTH }).required(),
    company: number().notOneOf(alreadyAttachedCompanyIds, t('installation.details.info.grant-access.company-is-used-error')).required(),
    writePermission: boolean().required(),
    readPermission: boolean().required(),
  })
  return { initialValues, validationSchema }
}
